const mutations = {
  UPDATE_FORM_COMPLETED(state, formCompleted) {
    state.formCompleted = formCompleted;
  },
  UPDATE_APP(state, appId) {
    state.appId = appId
  },
  UPDATE_INTAKE(state, intakeId) {
    state.intakeId = intakeId
  },
  UPDATE_PROGRAMME(state, programmeId) {
    state.programmeId = programmeId
  },
  UPDATE_ACADEMIC_LEVEL(state, academicLevelId) {
    state.academicLevelId = academicLevelId
  },
  UPDATE_COUNTRY(state, countryId) {
    state.countryId = countryId
  },
  UPDATE_COUNTRY1(state, countryId1) {
    state.countryId1 = countryId1
  },
  UPDATE_INSTITUTE(state, instituteId) {
    state.instituteId = instituteId
  },
  UPDATE_INSTITUTE_CATEGORY(state, instituteCategoryId) {
    state.instituteCategoryId = instituteCategoryId
  },
  UPDATE_INSTITUTE_NAME_OTHER(state, instituteNameOther) {
    state.instituteNameOther = instituteNameOther
  },
  UPDATE_COURSE1(state, course1Id) {
    state.course1Id = course1Id
  },
  UPDATE_COURSE2(state, course2Id) {
    state.course2Id = course2Id
  },
  UPDATE_IS_TECHNICAL(state, isTechnical) {
    state.isTechnical = isTechnical
  },
  UPDATE_INTERVIEW_ZONE(state, interviewZoneId) {
    state.interviewZoneId = interviewZoneId
  },
  UPDATE_START_DT(state, startDt) {
    state.startDt = startDt
  },
  UPDATE_END_DT(state, endDt) {
    state.endDt = endDt
  },
  UPDATE_DURATION_MONTH(state, durationMonth) {
    state.durationMonth = durationMonth
  },
  UPDATE_FIELD(state, fieldId) {
    state.fieldId = fieldId
  },
  UPDATE_FIELD_NAME_OTHER(state, fieldNameOther) {
    state.fieldNameOther = fieldNameOther
  },
  UPDATE_COURSE_NAME_OTHER(state, courseNameOther) {
    state.courseNameOther = courseNameOther
  },
  UPDATE_COUNTRY_NAME_OTHER(state, countryNameOther) {
    state.countryNameOther = countryNameOther
  },
  UPDATE_ACHIEVEMENT_RESULT(state, achievementResult) {
    state.achievementResult = achievementResult
  },
  UPDATE_FILE(state, file) {
    state.file = file
  },
  UPDATE_FORM_SUPPORTING_DOCUMENT_COMPLETED(state, formSupportingDocumentCompleted) {
    state.formSupportingDocumentCompleted = formSupportingDocumentCompleted;
  },
  UPDATE_FORM_PSYCHOMETRIC_COMPLETED(state, formPsychometricCompleted) {
    state.formPsychometricCompleted = formPsychometricCompleted;
  },
  UPDATE_COMPUTER_BRAND_ID(state, computerBrandId) {
    state.computerBrandId = computerBrandId
  },
  UPDATE_COMPUTER_BRAND_OTHERS(state, computerBrandOthers) {
    state.computerBrandOthers = computerBrandOthers
  },
  UPDATE_COMPUTER_LOAN_ACCOUNT_NUMBER(state, computerLoanAccountNumber) {
    state.computerLoanAccountNumber = computerLoanAccountNumber
  },
  UPDATE_COMPUTER_MODEL(state, computerModel) {
    state.computerModel = computerModel
  },
  UPDATE_COMPUTER_PRICE(state, computerPrice) {
    state.computerPrice = computerPrice
  },
  UPDATE_COMPUTER_TYPE_ID(state, computerTypeId) {
    state.computerTypeId = computerTypeId
  },
  UPDATE_PROGRAM_COMMON_ID(state, programCommonId) {
    state.programCommonId = programCommonId
  },
  UPDATE_MATRICULATION_NUMBER(state, matriculationNumber) {
    state.matriculationNumber = matriculationNumber
  },
  UPDATE_SKIPMA_ID(state, skipmaId) {
    state.skipmaId = skipmaId
  },
  UPDATE_SKIPMA_ACTIVE(state, skipmaActive) {
    state.skipmaActive = skipmaActive
  },
  UPDATE_SKIPMA_STATUS(state, skipmaStatus) {
    state.skipmaStatus = skipmaStatus
  },
  UPDATE_OTHER_COMPUTER_LOAN_DECLARATION(state, otherComputerLoanDeclaration) {
    state.otherComputerLoanDeclaration = otherComputerLoanDeclaration
  },
  UPDATE_IS_COCURRICULUM(state, isCocurriculum) {
    state.isCocurriculum = isCocurriculum
  },
  UPDATE_IS_INTERVIEW(state, isInterview) {
    state.isInterview = isInterview
  },
  UPDATE_IS_PSYCHOMETRIC(state, isPsychometric) {
    state.isPsychometric = isPsychometric
  },
  UPDATE_IS_SCHOOL(state, isSchool) {
    state.isSchool = isSchool
  },
  UPDATE_IS_SPMRESULT(state, isSPMResult) {
    state.isSPMResult = isSPMResult
  },
  UPDATE_PSYCHOMETRIC_COMPLETE(state, psychometricComplete) {
    state.psychometricComplete = psychometricComplete
  },
  UPDATE_PSYCHOMETRIC_COMPLETE_DT(state, psychometricCompleteDt) {
    state.psychometricCompleteDt = psychometricCompleteDt
  },
  UPDATE_SKIPMA_PIC_DOCUMENT_VERIFICATION(state, SKIPMA_PICDocumentVerification) {
    state.SKIPMA_PICDocumentVerification = SKIPMA_PICDocumentVerification
  },
  UPDATE_YTP_ID(state, ytpId) {
    state.ytpId = ytpId
  },
  UPDATE_YTP_COURSE_CHOICE_1(state, ytpCourseChoice1) {
    state.ytpCourseChoice1 = ytpCourseChoice1
  },
  UPDATE_YTP_COURSE_CHOICE_2(state, ytpCourseChoice2) {
    state.ytpCourseChoice2 = ytpCourseChoice2
  },
  UPDATE_SCORE_ID(state, scoreId) {
    state.scoreId = scoreId
  },
  UPDATE_STATUS_ID(state, statusId) {
    state.statusId = statusId
  },
  UPDATE_ATTEND_INTERVIEW(state, attendInterview) {
    state.attendInterview = attendInterview
  },
  UPDATE_INTAKE_START_DT(state, intakeStartDt) {
    state.intakeStartDt = intakeStartDt
  },
  UPDATE_INTAKE_END_DT(state, intakeEndDt) {
    state.intakeEndDt = intakeEndDt
  },
}

const actions = {
  updateFormCompleted({
    commit
  }, formCompleted) {
    commit('UPDATE_FORM_COMPLETED', formCompleted)
  },
  updateApp({
    commit
  }, appId) {
    commit('UPDATE_APP', appId);
  },
  updateIntake({
    commit
  }, intakeId) {
    commit('UPDATE_INTAKE', intakeId);
  },
  updateProgramme({
    commit
  }, programmeId) {
    commit('UPDATE_PROGRAMME', programmeId);
  },
  updateAcademicLevel({
    commit
  }, academicLevelId) {
    commit('UPDATE_ACADEMIC_LEVEL', academicLevelId);
  },
  updateCountry({
    commit
  }, countryId) {
    commit('UPDATE_COUNTRY', countryId);
  },
  updateCountry1({
    commit
  }, countryId1) {
    commit('UPDATE_COUNTRY1', countryId1);
  },
  updateInstitute({
    commit
  }, instituteId) {
    commit('UPDATE_INSTITUTE', instituteId);
  },
  updateInstituteCategory({
    commit
  }, instituteCategoryId) {
    commit('UPDATE_INSTITUTE_CATEGORY', instituteCategoryId);
  },
  updateInstituteNameOther({
    commit
  }, instituteNameOther) {
    commit('UPDATE_INSTITUTE_NAME_OTHER', instituteNameOther);
  },
  updateCourse1({
    commit
  }, course1Id) {
    commit('UPDATE_COURSE1', course1Id);
  },
  updateCourse2({
    commit
  }, course2Id) {
    commit('UPDATE_COURSE2', course2Id);
  },
  updateIsTechnical({
    commit
  }, isTechnical) {
    commit('UPDATE_IS_TECHNICAL', isTechnical);
  },
  updateInterviewZone({
    commit
  }, interviewZoneId) {
    commit('UPDATE_INTERVIEW_ZONE', interviewZoneId);
  },
  updateStartDt({
    commit
  }, startDt) {
    commit('UPDATE_START_DT', startDt);
  },
  updateEndDt({
    commit
  }, endDt) {
    commit('UPDATE_END_DT', endDt);
  },
  updateDurationMonth({
    commit
  }, durationMonth) {
    commit('UPDATE_DURATION_MONTH', durationMonth);
  },
  updateField({
    commit
  }, fieldId) {
    commit('UPDATE_FIELD', fieldId);
  },
  updateFieldNameOther({
    commit
  }, fieldNameOther) {
    commit('UPDATE_FIELD_NAME_OTHER', fieldNameOther);
  },
  updateCourseNameOther({
    commit
  }, courseNameOther) {
    commit('UPDATE_COURSE_NAME_OTHER', courseNameOther);
  },
  updateCountryNameOther({
    commit
  }, countryNameOther) {
    commit('UPDATE_COUNTRY_NAME_OTHER', countryNameOther);
  },
  updateAchievementResult({
    commit
  }, result) {
    commit('UPDATE_ACHIEVEMENT_RESULT', result);
  },
  updateFile({
    commit
  }, file) {
    commit('UPDATE_FILE', file);
  },
  updateFormSupportingDocumentCompleted({
    commit
  }, formSupportingDocumentCompleted) {
    commit('UPDATE_FORM_SUPPORTING_DOCUMENT_COMPLETED', formSupportingDocumentCompleted)
  },
  updateFormPsychometricCompleted({
    commit
  }, formPsychometricCompleted) {
    commit('UPDATE_FORM_PSYCHOMETRIC_COMPLETED', formPsychometricCompleted)
  },
  updateComputerBrandId({
    commit
  }, computerBrandId) {
    commit('UPDATE_COMPUTER_BRAND_ID', computerBrandId);
  },
  updateComputerBrandOthers({
    commit
  }, computerBrandOthers) {
    commit('UPDATE_COMPUTER_BRAND_OTHERS', computerBrandOthers);
  },
  updateComputerLoanAccountNumber({
    commit
  }, computerLoanAccountNumber) {
    commit('UPDATE_COMPUTER_LOAN_ACCOUNT_NUMBER', computerLoanAccountNumber);
  },
  updateComputerModel({
    commit
  }, computerModel) {
    commit('UPDATE_COMPUTER_MODEL', computerModel);
  },
  updateComputerPrice({
    commit
  }, computerPrice) {
    commit('UPDATE_COMPUTER_PRICE', computerPrice);
  },
  updateComputerTypeId({
    commit
  }, computerTypeId) {
    commit('UPDATE_COMPUTER_TYPE_ID', computerTypeId);
  },
  updateProgramCommonId({
    commit
  }, programCommonId) {
    commit('UPDATE_PROGRAM_COMMON_ID', programCommonId);
  },
  updateMatriculationNumber({
    commit
  }, matriculationNumber) {
    commit('UPDATE_MATRICULATION_NUMBER', matriculationNumber);
  },
  updateSkipmaId({
    commit
  }, skipmaId) {
    commit('UPDATE_SKIPMA_ID', skipmaId);
  },
  updateSkipmaActive({
    commit
  }, skipmaActive) {
    commit('UPDATE_SKIPMA_ACTIVE', skipmaActive);
  },
  updateSkipmaStatus({
    commit
  }, skipmaStatus) {
    commit('UPDATE_SKIPMA_STATUS', skipmaStatus);
  },
  updateOtherComputerLoanDeclaration({
    commit
  }, otherComputerLoanDeclaration) {
    commit('UPDATE_OTHER_COMPUTER_LOAN_DECLARATION', otherComputerLoanDeclaration);
  },
  updateIsCocurriculum({
    commit
  }, isCocurriculum) {
    commit('UPDATE_IS_COCURRICULUM', isCocurriculum);
  },
  updateIsInterview({
    commit
  }, isInterview) {
    commit('UPDATE_IS_INTERVIEW', isInterview);
  },
  updateIsPsychometric({
    commit
  }, isPsychometric) {
    commit('UPDATE_IS_PSYCHOMETRIC', isPsychometric);
  },
  updateIsSchool({
    commit
  }, isSchool) {
    commit('UPDATE_IS_SCHOOL', isSchool);
  },
  updateIsSPMResult({
    commit
  }, isSPMResult) {
    commit('UPDATE_IS_SPMRESULT', isSPMResult);
  },
  updatePsychometricComplete({
    commit
  }, psychometricComplete) {
    commit('UPDATE_PSYCHOMETRIC_COMPLETE', psychometricComplete);
  },
  updatePsychometricCompleteDt({
    commit
  }, psychometricCompleteDt) {
    commit('UPDATE_PSYCHOMETRIC_COMPLETE_DT', psychometricCompleteDt);
  },
  updateSKIPMA_PICDocumentVerification({
    commit
  }, SKIPMA_PICDocumentVerification) {
    commit('UPDATE_SKIPMA_PIC_DOCUMENT_VERIFICATION', SKIPMA_PICDocumentVerification);
  },
  updateYtpId({
    commit
  }, ytpId) {
    commit('UPDATE_YTP_ID', ytpId);
  },
  updateYtpCourseChoice1({
    commit
  }, ytpCourseChoice1) {
    commit('UPDATE_YTP_COURSE_CHOICE_1', ytpCourseChoice1);
  },
  updateYtpCourseChoice2({
    commit
  }, ytpCourseChoice2) {
    commit('UPDATE_YTP_COURSE_CHOICE_2', ytpCourseChoice2);
  },
  updateScoreId({
    commit
  }, scoreId) {
    commit('UPDATE_SCORE_ID', scoreId);
  },
  updateStatusId({
    commit
  }, statusId) {
    commit('UPDATE_STATUS_ID', statusId);
  },
  updateAttendInterview({
    commit
  }, attendInterview) {
    commit('UPDATE_ATTEND_INTERVIEW', attendInterview);
  },
  updateIntakeStartDt({
    commit
  }, intakeStartDt) {
    commit('UPDATE_INTAKE_START_DT', intakeStartDt);
  },
  updateIntakeEndDt({
    commit
  }, intakeEndDt) {
    commit('UPDATE_INTAKE_END_DT', intakeEndDt);
  },  
}

const getters = {
  FormCompleted: state => {
    return state.formCompleted
  },
  App: state => {
    return state.appId
  },
  Intake: state => {
    return state.intakeId
  },
  Programme: state => {
    return state.programmeId
  },
  AcademicLevel: state => {
    return state.academicLevelId
  },
  Country: state => {
    return state.countryId
  },
  Country1: state => {
    return state.countryId1
  },
  Institute: state => {
    return state.instituteId
  },
  InstituteCategory: state => {
    return state.instituteCategoryId
  },
  InstituteNameOther: state => {
    return state.instituteNameOther
  },
  Course1: state => {
    return state.course1Id
  },
  Course2: state => {
    return state.course2Id
  },
  IsTechnical: state => {
    return state.isTechnical
  },

  InterviewZone: state => {
    return state.interviewZoneId
  },
  StartDt: state => {
    return state.startDt
  },
  EndDt: state => {
    return state.endDt
  },
  DurationMonth: state => {
    return state.durationMonth
  },
  Field: state => {
    return state.fieldId
  },
  FieldNameOther: state => {
    return state.fieldNameOther
  },
  CourseNameOther: state => {
    return state.courseNameOther
  },
  CountryNameOther: state => {
    return state.countryNameOther
  },
  AchievementResult: state => {
    return state.achievementResult
  },
  File: state => {
    return state.file
  },
  FormSupportingDocumentCompleted: state => {
    return state.formSupportingDocumentCompleted
  },
  FormPsychometricCompleted: state => {
    return state.formPsychometricCompleted
  },
  ComputerBrandId: state => {
    return state.computerBrandId
  },
  ComputerBrandOthers: state => {
    return state.computerBrandOthers
  },
  ComputerLoanAccountNumber: state => {
    return state.computerLoanAccountNumber
  },
  ComputerModel: state => {
    return state.computerModel
  },
  ComputerPrice: state => {
    return state.computerPrice
  },
  ComputerTypeId: state => {
    return state.computerTypeId
  },
  ProgramCommonId: state => {
    return state.programCommonId
  },
  MatriculationNumber: state => {
    return state.matriculationNumber
  },
  SkipmaId: state => {
    return state.skipmaId
  },
  SkipmaActive: state => {
    return state.skipmaActive
  },
  SkipmaStatus: state => {
    return state.skipmaStatus
  },
  OtherComputerLoanDeclaration: state => {
    return state.otherComputerLoanDeclaration
  },
  IsCocurriculum: state => {
    return state.isCocurriculum
  },
  IsInterview: state => {
    return state.isInterview
  },
  IsPsychometric: state => {
    return state.isPsychometric
  },
  IsSchool: state => {
    return state.isSchool
  },
  IsSPMResult: state => {
    return state.isSPMResult
  },
  PsychometricComplete: state => {
    return state.psychometricComplete
  },
  PsychometricCompleteDt: state => {
    return state.psychometricCompleteDt
  },
  SKIPMA_PICDocumentVerification: state => {
    return state.SKIPMA_PICDocumentVerification
  },
  YtpId: state => {
    return state.ytpId
  },
  YtpCourseChoice1: state => {
    return state.ytpCourseChoice1
  },
  YtpCourseChoice2: state => {
    return state.ytpCourseChoice2
  },
  ScoreId: state => {
    return state.scoreId
  },
  StatusId: state => {
    return state.statusId
  },
  AttendInterview: state => {
    return state.attendInterview
  },
  IntakeStartDt: state => {
    return state.intakeStartDt
  },
  IntakeEndDt: state => {
    return state.intakeEndDt
  },
}

export default {
  namespaced: true,
  state() {
    return {
      formCompleted: true,
      appId: 0,
      intakeId: 0,
      programmeId: 0,
      academicLevelId: 0,
      countryId: 0,
      countryId1: 0,
      instituteId: 0,
      instituteCategoryId: 0,
      instituteNameOther: "",
      course1Id: 0,
      course2Id: 0,
      isTechnical: 0,
      interviewZoneId: 0,
      startDt: 0,
      endDt: 0,
      durationMonth: 0,
      fieldId: 0,
      fieldNameOther: "",
      courseNameOther: "",
      countryNameOther: "",
      achievementResult: "",
      file: "",
      formSupportingDocumentCompleted: true,
      formPsychometricCompleted: true,
      computerBrandId: 0,
      computerBrandOthers: "",
      computerLoanAccountNumber: "",
      computerModel: "",
      computerPrice: 0,
      computerTypeId: 0,
      programCommonId: 0,
      matriculationNumber: 0,
      skipmaId: 0,
      skipmaActive: 0,
      skipmaStatus: -1,
      otherComputerLoanDeclaration: 0,
      isCocurriculum: 0,
      isInterview: 0,
      isPsychometric: 0,
      isSchool: 0,
      isSPMResult: 0,
      psychometricComplete: 0,
      psychometricCompleteDt: 0,
      SKIPMA_PICDocumentVerification: {},
      ytpId: 0,
      ytpCourseChoice1: 0,
      ytpCourseChoice2: 0,
      scoreId: 0,
      statusId: 0,
      attendInterview: 0,
      intakeStartDt: "",
      intakeEndDt: "",
    }
  },
  getters,
  actions,
  mutations
}
